import React from 'react';
import Target from '@Components/Results/targets/Target';
import Reaction from '@Components/Results/reactions/Reaction';
import Document from '@Components/Results/documents/Document';
import Substance from '@Components/Results/substances/Substance';
// Patent Family Clustering
import PatentFamilyGroupContainer from '@Containers/PatentFamilyClustering/PatentFamilyGroupContainer';
import SinglePatentFromFamilyContainer from '@Containers/PatentFamilyClustering/SinglePatentFromFamilyContainer';
import { isPatentFamilyGroup, isSinglePatentFromFamily } from '@Containers/PatentFamilyClustering/utils';

const renderers = {
  reactions: (result, props) => <Reaction reaction={result} {...props} />,
  substances: (result, props) => <Substance substance={result} {...props} />,
  tgitems: (result, props) => <Target target={result} {...props} />,
  citations: (result, props) => {
    const { metadata } = props;
    if (metadata.isViewPreview) {
      return <Document document={result} {...props} />;
    }

    if (isPatentFamilyGroup(result)) {
      return <PatentFamilyGroupContainer document={result} {...props} />;
    }

    if (isSinglePatentFromFamily(result)) {
      return <SinglePatentFromFamilyContainer document={result} {...props} />;
    }

    return <Document document={result} {...props} />;
  },
};

const ResultRenderer = {
  render(context, props) {
    const { result, ...rest } = props;
    const renderer = renderers[context];

    if (!renderer) throw new Error('Specified context is not yet implemented');
    if (!result) throw new Error('Invalid result param passed');

    return renderer(result, rest);
  },
};

export default ResultRenderer;
